import instamapsBreadcrumbs from '../shared/components/breadcrumbs/breadcrumbs.vue';
import messages from './politica-translations';


export default {
    name: 'instamapsPolitica',
    data: () => {
        return {
        };
    },
    i18n: {
        messages,
    },
    components: {
        instamapsBreadcrumbs,
    },
    props: {
        hasBreadcrumbs: { type: Boolean },
    },
    methods: {
        
    },
};



// WEBPACK FOOTER //
// ./src/politica/politica.js